// extracted by mini-css-extract-plugin
export var arrowDownIcon = "styles-module--arrowDownIcon--b2c84";
export var arrowUpIcon = "styles-module--arrowUpIcon--82416";
export var link = "styles-module--link--23d90";
export var linkIcon = "styles-module--linkIcon--e337c";
export var linkItem = "styles-module--linkItem--10009";
export var linksList = "styles-module--linksList--944fe";
export var open = "styles-module--open--b26c3";
export var other = "styles-module--other--850b1";